import { render, staticRenderFns } from "./SignupAuthentication.vue?vue&type=template&id=45c2f6e4"
import script from "./SignupAuthentication.vue?vue&type=script&lang=js"
export * from "./SignupAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports